import React from 'react';
import PropTypes from 'prop-types';
import styles from './ResultIndicator.module.css';

const mapStatusToColor = (statusCode) => {
  if (statusCode === undefined || statusCode === null) return null;

  switch (statusCode) {
    case 0: return 'var(--medium-gray)';       // NA
    case 1: return 'var(--primary)';           // Verde (usando primary)
    case 2: return 'var(--warning)';           // Amarelo
    case 3: return 'var(--danger)';            // Vermelho
    case 4: return 'var(--dark-gray)';         // Cinza
    default: return null;
  }
};

const ResultIndicator = ({
  label,
  value,
  prefix = '',
  indicator = null,
  colorStatus = null
}) => {
  const useColorStatus = colorStatus !== null && colorStatus !== undefined;
  const backgroundColor = useColorStatus ? mapStatusToColor(colorStatus) : null;

  return (
    <div className={styles.resultValue}>
      <div className={styles.resultLabel}>{label}</div>
      <div className={styles.resultNumber}>
        {(indicator === true || useColorStatus) && (
          <span
            className={styles.indicator}
            style={backgroundColor ? { backgroundColor } : {}}
          ></span>
        )}
        {prefix}{value}
      </div>
    </div>
  );
};

ResultIndicator.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  prefix: PropTypes.string,
  indicator: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([null])]),
  colorStatus: PropTypes.oneOf([0, 1, 2, 3, 4, null])
};

ResultIndicator.defaultProps = {
  prefix: '',
  indicator: null,
  colorStatus: null
};

export default ResultIndicator;